window.addEventListener("load", (event) => {
	document.querySelectorAll("[data-video-preload]").forEach((el) => {
		const video = el.querySelector("video");
		const image = el.querySelector("img");

		video.src = video.dataset.src;
		video.style.display = "block";
	});
});
